// JavaScript Document

$(function() {
    var $select = $('.filter-option'),
        $container = $('.neo4j-user-logos'),
        qsRegex, // quick search regex 
        $quicksearch = $('.quicksearch'),
        stateObj = {
          filter: '', 
          value: '',
        };

    // Set state from parameters
    set_state_from_url();

    // Init Isotope
    $container.imagesLoaded( function() {
        $container.isotope({
            layoutMode: 'fitRows',
            itemSelector: '.customer-box',
            filter: getFilter()
        });
    });

    // Bind filter changes
    $select.change(filter_options).keyup(filter_options);
    // use value of search field to filter
    $quicksearch.keyup( debounce( function() {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $container.isotope();
    }, 200 ) );

    // Stop search form submit
    $('#searchform').on('submit', function(e) { e.preventDefault() } );

    // Show full page when see more clicked    
    $('#see-more-button').on("click", unhide_overflow_companies);

    function set_state_from_url() {
        let addr = new URL(window.location);
        if (addr.searchParams.has('industry') || 
            addr.searchParams.has('use-case') || 
            addr.searchParams.has('search')) {

            for(var pair of addr.searchParams.entries()) {
                stateObj.filter = pair[0]
                stateObj.value = pair[1]
                // Add period before class based filters
                if (stateObj.filter != 'search') {
                    stateObj.value = '.' + stateObj.value;
                }
                // Filter out trailing slash if pulled from URL
                if (stateObj.value.slice(-1) == '/') {
                    stateObj.value = stateObj.value.slice(0,-1);
                }
            }

            //Update select value
            $('#'+stateObj.filter).val(stateObj.value);
            // If search, setup quicksearch value
            if (stateObj.filter == 'search') {
                qsRegex = new RegExp( stateObj.value, 'gi' );
            }
        } else {
            // Reset state obj
            stateObj = {
              filter: '', 
              value: '',
            };
        }
    }

    // Update filters when using browser history navigation
    window.onpopstate = function(event) {
        //console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));

        set_state_from_url()

        if (stateObj.filter != '') {
            reset_other_filters();

        // Reset state obj, filter selects and refilter isotope
        } else {
            // Reset all filter selects
            $select.each(function(){
                // If select set to all
                $(this).val('*');
                // If search set to empty string
                if (this.id == 'search') $(this).val('');
            });
        }
        // Filter items
        $container.isotope({
            filter: getFilter()
        });
    };
  
    function filter_options(){
        // Update stateObj
        stateObj.filter = this.id;
        stateObj.value = $(this).val();

        reset_other_filters()

        // Filter items
        $container.isotope({
            filter: getFilter()
        });

        // Show all items after layout change
        $container.isotope( 'on', 'layoutComplete', function (isoInstance, laidOutItems) {
            $("#logo-hide-window").css("height", "inherit");
            $('#see-more-button').hide();
        });
        
        // Tracking info
        dataLayer.push({
            'event': 'virtualEvent',
            'eventCategory': 'web_programs',
            'eventAction': 'engagement',
            'eventLabel': 'customers_filter'
        });

        /* Update url parameters */
        // Get url root
        const url = new URL(window.location.href.split('?')[0]);
        // Don't set param if filter is 'all', just use unfiltered state
        if (stateObj.value != '*') {
            // Remove periods from class based filters
            let value = stateObj.value.replace('.','')
            // Add current filter state as parameter
            url.searchParams.set(stateObj.filter, value); 
        }
        // Push to browser history
        window.history.replaceState({}, '', url );

    }

    // Reset other inactive filters
    function reset_other_filters() {
        $select.each(function(){
            if (this.id != stateObj.filter) {
                // If select set to all
                $(this).val('*');
                // If search set to empty string
                if (this.id == 'search') $(this).val('');
            }
        });
    }

    // Returns filter for isotope
    // either filter string or query match function
    function getFilter() {
        if (stateObj.filter == 'search') {
            // Run match on search field
            return function() { 
                return qsRegex ? $('.customer.plaintext', this).text().match( qsRegex ) : true; 
            }
        }

        return stateObj.value;
    }

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout( timeout );
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply( _this, args );
        }
        timeout = setTimeout( delayed, threshold );
        };
    } 

    function unhide_overflow_companies(){
        var height_of_all_logos = $('.neo4j-user-logos').css('height');
        var current_height_of_window = $('#logo-hide-window').css('height');
        $('#logo-hide-window').height(height_of_all_logos);
        $('#see-more-button').hide();
    }
});

// Add inline styles
$("select").css("outline", "none");
$("select").css("box-shadow", "none");

// Make whole box link to anchor
$(".customer-page .customer-boxed .customer-box.has_case_study").click(function() {
    window.location = $(this).find("a").attr("href");
    return false;
});

// Make whole box link to anchor
$(".customer-page .customer-boxed .customer-box.has_learn_more").click(function() {
    window.location = $(this).find("a").attr("href");
    return false;
});

// Add custom hover class to case studies
$(".customer-page .customer-boxed .customer-box.has_case_study").hover(
    function() {
        $(this).addClass('logo-hover');
    },
    function() {
        $(this).removeClass('logo-hover');
} );

// Add custom hover class to learn more
$(".customer-page .customer-boxed .customer-box.has_learn_more").hover(
    function() {
        $(this).addClass('logo-hover');
    },
    function() {
        $(this).removeClass('logo-hover');
} );

// Add hover effect to top slider on hover
$(".customer-page .medium-12.slide-text.columns").hover(
    function() {
        $(this).addClass('slider-hover');
    }, function() {
        $(this).removeClass('slider-hover');
    } );

// Make full slider clickable
$(".customer-page .medium-12.slide-text.columns").click(function() {
    window.location = $(this).find("a").attr("href");
    return false;
});

